import { useEffect, useState } from "react";
import { PropertyTypeClient, PropertyTypeDTO } from "../services/apiClient";
import { API_BASE_URL } from "../config/config";
import axiosInstance from "../services/axiosInstance";

export const getPropertyTypes = () => {
  const [propertyTypes, setPropertyTypes] = useState<PropertyTypeDTO[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  const propertyTypeClient = new PropertyTypeClient(API_BASE_URL, axiosInstance);

  useEffect(() => {
          const fetchPropertyTypeNames = async () => {
              setIsLoading(true);
              try {
                  const result = await propertyTypeClient.getPropertyTypes(); // Call the distinct table names endpoint
                  if (result && result.success && result.data) {
                    setPropertyTypes(result.data);
                  } else {
                      setError('Failed to fetch property types names');
                  }
              } catch (err) {
                  setError('Error fetching property types names');
                  console.error('Error fetching property types names:', err);
              } finally {
                  setIsLoading(false);
              }
          };
  
          fetchPropertyTypeNames();
      }, []);
  
      return { propertyTypes, isLoading, error };
};
